import axios from "axios";
import {GET_ADDRESS_BY_NOMINEE, GET_NOMINEE, GET_NONCE, LOGIN, VOTE} from "API/url";
import {
    AddressByNomineeDataType,
    IApiServices,
    LoginDataType,
    NomineeDataType,
    NonceDataType,
    TokenType,
    VoteDataType,
} from "API/types";

export const ApiServices: IApiServices = {
    async login(address, signature) {
        const data: LoginDataType = {
            address,
            signature,
        };

        return await axios.post(LOGIN, data);
    },

    async vote(nominee_id, token: TokenType) {
        const data: VoteDataType = {
            nominee_id,
        };

        return await axios.post(VOTE, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
    },

    async getNonce(address) {
        const data: NonceDataType = {
            address,
        };

        return await axios.post(GET_NONCE, data);
    },

    async getNominees(address) {
        const data: NomineeDataType = {
            address,
        };

        return await axios.post(GET_NOMINEE, data);
    },

    async getAddressByNominee(nominee_id, page) {
        const data: AddressByNomineeDataType = {
            nominee_id,
            page,
        };

        return await axios.post(GET_ADDRESS_BY_NOMINEE, data);
    },
}

